/* eslint-disable
  strict
*/

'use strict';

const validateOptions = require('./validateOptions');

module.exports = validateOptions;



//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/node_modules/schema-utils/src/index.js
// module id = OXfi
// module chunks = 1